module.exports = __webpack_public_path__ + "static/media/Jolteon_gaussian2.e0c67f33.png";